import { DateTime } from "luxon";
import { MonthPlanNextEntity } from "modules/finances/widgets/month-plan-list/ui/month-plan-next";
import React, { CSSProperties } from "react";
import { api, MonthPlanCommonNextMonthPlanDto } from "shared/api";

export interface ICreateFirst {
  companySlug: string;
  onCreate: (data: MonthPlanCommonNextMonthPlanDto) => void;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const CreateFirst = (props: ICreateFirst) => {
  const current = DateTime.now();
  const prev = current.minus({ month: 1 });
  const next = current.plus({ month: 1 });

  const currentPlan = api.monthPlan.useMonthPlanCommonNextMonthPlan(props.companySlug, current.year, current.month);
  const prevPlan = api.monthPlan.useMonthPlanCommonNextMonthPlan(props.companySlug, prev.year, prev.month);
  const nextPLan = api.monthPlan.useMonthPlanCommonNextMonthPlan(props.companySlug, next.year, next.month);

  const showPrev = prevPlan.data?.to! > new Date();

  return (
    <>
      {nextPLan.data && <MonthPlanNextEntity data={nextPLan.data} onCreate={props.onCreate} />}
      {currentPlan.data && <MonthPlanNextEntity data={currentPlan.data} onCreate={props.onCreate} />}
      {prevPlan.data && <MonthPlanNextEntity data={prevPlan.data} onCreate={props.onCreate} />}
    </>
  );
};

CreateFirst.defaultProps = {};
